import './screen-size';
import './navigation';
import './table-of-contents';
import './togglize';
import './columnize';
import 'SLICK/slick.js';
import 'MFP/jquery.magnific-popup.js';
import './hero-video';
import { defineCustomElements } from '@smore/core';
defineCustomElements(window);

(function ($) {

  $(document).ready(function () {

    console.log('starter theme...');

    function reduceAllMotion() {
      console.log('reducing motion...');
      $('video').prop('autoplay', false)
        .siblings('.video-control-button-container').find('.video-control-button').attr('aria-label', 'play');
    }

    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }

    let $faqToggles = $(".faq-column").togglize({ action: "toggle", animate: true, animateSpeed: "1s", firstOpen: false, adaptiveHeight: true });
    let $toggles = $(".togglize-me").togglize({ action: "toggle", animate: true, animateSpeed: "1s", firstOpen: false });
    let $accordions = $(".accordionize-me").togglize({ action: "accordion", animate: true, animateSpeed: "0.75s" })
    let twoCols = $(".two-col-content").twoColumnize()

    $('.testimonial-slider').slick({
      infinite: true,
      slidesToShow: 2,
      centerMode: true,
      centerPadding: '4rem',
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            dots: true,
            arrows: false
          }
        },
      ]
    });


    $('.standard-image-slider').slick({
      infinite: true,
      slidesToShow: 1,
      rows: 0,
      centerMode: true,
      centerPadding: '15%',
      dots: true,
      arrows: true,
      prevArrow: `
        <button type="button" class="slick-prev custom-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="45" viewBox="0 0 49 45" fill="none">
            <g clip-path="url(#clip0_30_278)">
              <path d="M10.5635 24.3849C10.5635 23.9236 10.7519 23.5547 11.0344 23.1857L13.4827 20.7874L23.2758 11.2863C23.5583 10.9173 24.0291 10.8251 24.5 10.8251C24.9708 10.8251 25.3474 10.9173 25.7241 11.2863L28.1724 13.6846C28.4549 13.9614 28.6432 14.4226 28.6432 14.8838C28.6432 15.345 28.4549 15.714 28.1724 15.9907L23.0875 20.9719L36.5531 20.9719C37.0239 20.9719 37.4005 21.1563 37.7772 21.5253C38.0597 21.802 38.248 22.2633 38.248 22.7245L38.248 26.0452C38.248 26.5064 38.0597 26.9677 37.7772 27.2444C37.4005 27.6134 37.0239 27.7979 36.5531 27.7979L23.0875 27.7979L28.1724 32.779C28.4549 33.0557 28.6432 33.4247 28.6432 33.8859C28.6432 34.4394 28.4549 34.8083 28.1724 35.0851L25.7241 37.4834C25.3474 37.8524 24.9708 37.9446 24.5 37.9446C24.0291 37.9446 23.5583 37.8524 23.2758 37.4834L13.4827 27.9823L11.0344 25.584C10.7519 25.215 10.5635 24.8461 10.5635 24.3849ZM3.87784 24.3849C3.87784 28.0746 4.72532 31.4876 6.60862 34.5316C8.49192 37.6679 10.9402 40.0662 14.1418 41.9111C17.2493 43.7559 20.7334 44.5861 24.5 44.5861C28.2666 44.5861 31.7507 43.7559 34.8581 41.9111C38.0597 40.0662 40.508 37.6679 42.3913 34.5316C44.2746 31.4876 45.1221 28.0746 45.1221 24.3849C45.1221 20.6951 44.2746 17.2821 42.3913 14.2381C40.508 11.1018 38.0597 8.70351 34.8581 6.85865C31.7507 5.01378 28.2666 4.1836 24.5 4.1836C20.7334 4.1836 17.2493 5.01378 14.1418 6.85865C10.9402 8.70351 8.49192 11.1018 6.60862 14.2381C4.72532 17.2821 3.87784 20.6951 3.87784 24.3849Z" fill="#76D0F1"/>
            </g>
            <defs>
              <clipPath id="clip0_30_278">
                <rect width="49" height="44" fill="white" transform="matrix(-1 0 0 1 49 0.770508)"/>
              </clipPath>
            </defs>
          </svg>
        </button>
      `,
      nextArrow: `
        <button type="button" class="slick-next custom-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="45" viewBox="0 0 50 45" fill="none">
            <g clip-path="url(#clip0_30_285)">
              <path d="M38.5263 21.1562C38.5263 21.6174 38.338 21.9864 38.0555 22.3553L35.6072 24.7536L25.814 34.2547C25.5315 34.6237 25.0607 34.7159 24.5899 34.7159C24.1191 34.7159 23.7424 34.6237 23.3657 34.2547L20.9175 31.8564C20.635 31.5796 20.4466 31.1184 20.4466 30.6572C20.4466 30.196 20.635 29.827 20.9175 29.5503L26.0024 24.5692H12.5368C12.066 24.5692 11.6893 24.3847 11.3126 24.0157C11.0301 23.739 10.8418 23.2778 10.8418 22.8165V19.4958C10.8418 19.0346 11.0301 18.5734 11.3126 18.2966C11.6893 17.9277 12.066 17.7432 12.5368 17.7432H26.0024L20.9175 12.762C20.635 12.4853 20.4466 12.1163 20.4466 11.6551C20.4466 11.1017 20.635 10.7327 20.9175 10.456L23.3657 8.05763C23.7424 7.68866 24.1191 7.59642 24.5899 7.59642C25.0607 7.59642 25.5315 7.68866 25.814 8.05763L35.6072 17.5587L38.0555 19.957C38.338 20.326 38.5263 20.6949 38.5263 21.1562ZM45.212 21.1562C45.212 17.4664 44.3645 14.0534 42.4812 11.0094C40.5979 7.87315 38.1496 5.47482 34.948 3.62996C31.8406 1.7851 28.3565 0.954906 24.5899 0.954906C20.8233 0.954906 17.3392 1.7851 14.2318 3.62996C11.0301 5.47482 8.58185 7.87315 6.69856 11.0094C4.81526 14.0534 3.96777 17.4664 3.96777 21.1562C3.96777 24.8459 4.81526 28.2589 6.69856 31.3029C8.58185 34.4392 11.0301 36.8375 14.2318 38.6824C17.3392 40.5272 20.8233 41.3574 24.5899 41.3574C28.3565 41.3574 31.8406 40.5272 34.948 38.6824C38.1496 36.8375 40.5979 34.4392 42.4812 31.3029C44.3645 28.2589 45.212 24.8459 45.212 21.1562Z" fill="#76D0F1"/>
            </g>
            <defs>
              <clipPath id="clip0_30_285">
                <rect width="49" height="44" fill="white" transform="matrix(1 0 0 -1 0.0898438 44.7705)"/>
              </clipPath>
            </defs>
          </svg>
        </button>
      `,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            dots: true,
            arrows: false
          }
        },
      ]
    });


    // Ensure already loaded images are visible
    $('#event-posts img').each(function () {
      if (this.complete) {
        $(this).addClass('loaded'); // If image is already loaded, add class
      } else {
        $(this).on('load', function () {
          $(this).addClass('loaded');
        });
      }
    });

    let button = $('#load-more-events');

    if (button.length === 0) {
      return; // Stop execution if the button doesn't exist
    }

    button.on('click', function () {
      let page = parseInt(button.data('page'));
      let ajaxurl = button.data('url');

      $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'load_more_events',
          page: page
        },
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (response) {
          if ($.trim(response)) {
            let newPosts = $(response);

            // Set lazy-load class before appending
            newPosts.find('img').addClass('lazy-load');

            $('#event-posts').append(newPosts);
            button.data('page', page + 1);
            button.text('Load More Events').prop('disabled', false);

            // Lazy Load Images AFTER they are added to the page
            $('#event-posts img.lazy-load').each(function () {
              $(this).on('load', function () {
                $(this).addClass('loaded');
              });
            });

          } else {
            button.text('No More Events').prop('disabled', true);
          }
        }
      });
    });

  })
})(jQuery);